var _rect, _g, _polyline, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUptrendCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#050e1a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 200,
    width: 18,
    height: 60,
    fill: "#e05a5a",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: 190,
    x2: 129,
    y2: 270,
    stroke: "#e05a5a",
    strokeWidth: 1.5,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 190,
    width: 18,
    height: 50,
    fill: "#e05a5a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 180,
    x2: 169,
    y2: 250,
    stroke: "#e05a5a",
    strokeWidth: 1.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 170,
    width: 18,
    height: 55,
    fill: "#4a7a3a",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209,
    y1: 160,
    x2: 209,
    y2: 235,
    stroke: "#4a7a3a",
    strokeWidth: 1.5,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 150,
    width: 18,
    height: 45,
    fill: "#4a7a3a"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249,
    y1: 138,
    x2: 249,
    y2: 205,
    stroke: "#4a7a3a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 160,
    width: 18,
    height: 50,
    fill: "#4a7a3a",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289,
    y1: 148,
    x2: 289,
    y2: 220,
    stroke: "#4a7a3a",
    strokeWidth: 1.5,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 130,
    width: 18,
    height: 60,
    fill: "#4a7a3a"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329,
    y1: 118,
    x2: 329,
    y2: 200,
    stroke: "#4a7a3a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 120,
    width: 18,
    height: 45,
    fill: "#4a7a3a",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369,
    y1: 108,
    x2: 369,
    y2: 175,
    stroke: "#4a7a3a",
    strokeWidth: 1.5,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 100,
    width: 18,
    height: 55,
    fill: "#4a7a3a"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409,
    y1: 88,
    x2: 409,
    y2: 165,
    stroke: "#4a7a3a",
    strokeWidth: 1.5
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "120,240 200,200 280,175 360,140 440,105",
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 2,
    strokeDasharray: "6 3",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 338,
    fontFamily: "Georgia, serif",
    fontSize: 10,
    fill: "#fff",
    opacity: 0.2,
    letterSpacing: 3
  }, "UPTREND \xB7 ALGO TRADING")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 42,
    fontFamily: "Georgia, serif",
    fontSize: 9,
    fill: "#4a7a3a",
    letterSpacing: 4
  }, "PYTHON \xB7 BACKTESTING")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptrendCover);
export default __webpack_public_path__ + "static/media/uptrend-cover.d48a0ec1fcc6b2e0ab657c975e5b9168.svg";
export { ForwardRef as ReactComponent };